import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

import { fetchPurchaseLocationsApi, fetchReportHistoryApi, fetchReportsApi } from './reports.api';
import {
  fetchPurchaseLocationsFailure,
  fetchPurchaseLocationsRequest,
  fetchPurchaseLocationsSuccess,
  fetchReportHistoryFailure,
  fetchReportHistoryRequest,
  fetchReportHistorySuccess,
  fetchReportsFailure,
  fetchReportsRequest,
  fetchReportsSuccess,
} from './reports.slice';

import { ShipmentLocation, StoneReportData } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchReportsSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: StoneReportData = yield call(fetchReportsApi, action.payload);
    yield put(fetchReportsSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchReportsFailure, 'Failed to fetch reports');
  }
}

function* fetchReportHistorySaga(action: PayloadAction<{ tab: 'shipments' | 'receipts'; params: any }>): Generator<any, void, any> {
  const { tab, params } = action.payload;
  try {
    const response: { items: any[]; totalCount: number } = yield call(fetchReportHistoryApi, params);
    yield put(fetchReportHistorySuccess({ tab, items: response.items, totalCount: response.totalCount }));
  } catch (error: any) {
    toast.error(toast.parseErrorMessage(error, 'Failed to load report history'));
    yield put(fetchReportHistoryFailure({ tab, error: String(error.message) }));
  }
}

function* fetchPurchaseLocationsSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: ShipmentLocation[] = yield call(fetchPurchaseLocationsApi, action.payload);
    yield put(fetchPurchaseLocationsSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchPurchaseLocationsFailure, 'Failed to fetch purchase locations');
  }
}

export default function* reportsSaga() {
  yield takeLatest(fetchReportsRequest.type, fetchReportsSaga);
  yield takeLatest(fetchReportHistoryRequest.type, fetchReportHistorySaga);
  yield takeLatest(fetchPurchaseLocationsRequest.type, fetchPurchaseLocationsSaga);
}
